import type { DeliveryOption, UserDelivery } from '../../types/products';

interface DeliveryInfoProps {
  deliveryPrice: number;
  deliveryOptions: DeliveryOption[];
  userDelivery: UserDelivery | null;
}

function formatPrice(price: number): string {
  return price.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function DeliveryInfo({ deliveryPrice, deliveryOptions, userDelivery }: DeliveryInfoProps) {
  return (
    <div className="border-t border-b border-gray-200 pt-4 pb-4">
      <h4 className="mb-2 text-sm font-medium text-gray-700">
        <i className="fa fa-truck mr-1.5 text-green-600" />
        Envío
      </h4>
      <p className="mb-3 text-sm text-gray-600">
        {userDelivery?.free_delivery ? (
          <><strong className="text-green-600">Envío gratis</strong> en tu próximo pedido</>
        ) : (
          <>Costo de envío: <strong>${formatPrice(deliveryPrice)}</strong></>
        )}
      </p>

      {userDelivery ? (
        <p className="m-0 text-sm text-gray-600">
          Recibilo en <span className="font-medium text-gray-700">{userDelivery.address.split(',')[0]}</span> el{' '}
          {userDelivery.day.toLowerCase()} entre las {userDelivery.start_time} y {userDelivery.end_time}.
        </p>
      ) : deliveryOptions.length > 0 ? (
        <div className="space-y-1">
          <p className="m-0 mb-1 text-sm font-medium text-gray-700">Entregas programadas</p>
          {deliveryOptions.map((opt, i) => (
            <p key={i} className="m-0 text-sm text-gray-600">
              <span className="font-medium text-gray-700">{opt.zone_title}</span>
              {' · '}
              {opt.day.toLowerCase()} {opt.start_time}–{opt.end_time}
            </p>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500">
          <i className="fa fa-info-circle mr-1" />
          No hay entregas programadas para los próximos días. Contactános para más información.
        </p>
      )}
    </div>
  );
}
